<template lang="pug">
pr-wrapper.cms-detail-boxed(fs, bg, :bgo="gradient ? '.5' : '.85'")
  .overlay(:class="{gradient:gradient, 'surface-bg': !gradient}")
  .header.row.no-gutters.align-items-center
    .col.p-4(v-html="$t('press.backToBack')", style="whitespace: nowrap" v-visible="backButton")
    .col.col-auto.p-4
      info-bar(scope="cdb-infobar", data-down="cms-actions|cms-description|cms-carousel", @nv-back="close")
  .cdb-wrapper
    .cdb-aside(:class="{ withVideo: video }")
      .cdb-video.surface-bg.border.shadow(:class="[content.orientation || 'horizontal']", v-if="video")
        #cdb-video.h-100.w-100
      carousel.shadow(
        v-else-if="gallery.length",
        :images="gallery",
        vertical,
        arrows,
        data-up="cdb-infobar",
        data-right="cms-actions|cms-description",
        @nv-back="close"
      )
    .cdb-section.h-100.surface-bg.border.shadow(:class="{ 'px-5': !isSimple, 'px-4': isSimple }")
      .cdb-title.pt-5.pb-3.d-flex
        pr-subtitle(weight="semibold") {{ content.title }}
      .cdb-actions(v-if="hasAction")
        actions(
          @cart="addToCart",
          :data="content",
          data-up="cdb-infobar",
          data-left="cms-carousel",
          data-down="cms-description",
          navigate,
          @nv-back="close"
        )
      .cdb-content.pb-5.pt-3
        description(
          :content="content.description",
          data-up="cms-actions|cdb-infobar",
          data-left="cms-carousel",
          @nv-back="close",
          style="max-height: 311px; text-align: left"
        )
</template>

<script>
import carousel from "./helpers/carousel.vue"
import actions from "../layouts/actions.vue"
import description from "./helpers/description.vue"
export default {
  name: "cms-detail-boxed",
  components: { actions, carousel, description },
  props: ["content", "prevRoute"],
  computed: {
    backButton() {
      return __.device.config("cms_back_button_behaviour.cms_back_button_behaviour") === "enable"
    },
    gradient() {
      return this.content.layout_gradient === "gradient"
    },
    gallery() {
      return this.content?.gallery || []
    },
    cover() {
      return this.gallery.slice(0, 1).shift()
    },
    video() {
      return this.content.video || false
    },
    hasAction() {
      return (
        (["appointment", "reservation", "request"].includes(this.content.action_type) && this.content?.endpoint !== "pms") ||
        (["product"].includes(this.content.action_type) && this.content.price)
      )
    },
    isSimple() {
      return this.video && this.content.orientation === "square"
    }
  },
  async activated() {
    if (this.cover) __.platform.background(this.cover.large, this.video).then(() => this.video && this.resizeMediaWrapper("cdb-video"))
    else if (this.video) __.media.play(this.video, true).then(() => this.resizeMediaWrapper("cdb-video"))

    if (document.getElementById("cms-actions")?.offsetParent) _$.nav.changeScope("cms-actions")
    else if (document.getElementById("cms-description")?.offsetParent) _$.nav.changeScope("cms-description")
    else if (document.getElementById("cms-carousel")?.offsetParent) _$.nav.changeScope("cms-carousel")
  },
  methods: {
    resizeMediaWrapper(id) {
      document.body.contains(this.$el) ? __.common.tvWindowResize(id) : __.media.stop()
    },
    close() {
      __.platform.go(this.prevRoute)
    },
    addToCart(payload) {
      __.order.add(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-detail-boxed {
  display: flex;
  align-items: center;
  justify-content: center;

  .overlay {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;

    &.gradient {
      top: 0 !important;
      background: rgb(0, 0, 0);
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.95) 10%, rgba(0, 0, 0, 0.5046393557422969) 70%, rgba(0, 0, 0, 0) 100%);
    }
  }

  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .cdb-wrapper {
    position: absolute;
    width: 1024px;
    height: 526px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;

    .cdb-aside {
      position: relative;
      display: flex;
      align-items: center;
      height: 100%;
      max-width: 60%;
      flex-shrink: 0;

      .cdb-video {
        border-right: 0 !important;
        align-items: center;
        display: flex;

        &.vertical {
          width: 296px;
          height: 526px;
        }
        &.square {
          width: 701px;
          height: 526px;
        }
        &.horizontal {
          width: 512px;
          height: 288px;
        }
      }

      &.withVideo {
        max-width: none !important;
      }
    }
    .cdb-section {
      position: relative;
      flex-direction: column;
      flex-grow: 1;
      display: flex;
      justify-content: center;

      .cdb-content {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 0 1 auto;
        overflow: hidden;
      }
    }
  }
}
</style>
